export default __webpack_public_path__ + "static/media/Logo_white.235a9b94.svg";